// import React, { useState, useRef, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import './SignUp.css';

// const SignUp = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     fullName: '',
//     email: '',
//     dateOfBirth: '',
//     otp: ''
//   });
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [otpStep, setOtpStep] = useState(false);

//   const otpInputRef = useRef();

//   useEffect(() => {
//     if (otpStep && otpInputRef.current) {
//       otpInputRef.current.focus();
//     }
//   }, [otpStep]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     if (errors[name]) {
//       setErrors(prev => ({
//         ...prev,
//         [name]: ''
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.fullName.trim()) newErrors.fullName = 'Full name is required';
//     if (!formData.email.trim()) {
//       newErrors.email = 'Email is required';
//     } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//       newErrors.email = 'Email is invalid';
//     }
//     if (!formData.dateOfBirth) newErrors.dateOfBirth = 'Date of birth is required';

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     setIsLoading(true);

//     try {
//       if (!otpStep) {
//         const response = await fetch('https://noteapp-0eu4.onrender.com/api/auth/signup', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             name: formData.fullName,
//             email: formData.email,
//             dob: formData.dateOfBirth,
//           }),
//         });

//         const data = await response.text();
//         if (!response.ok) throw new Error(data.message || 'Signup failed');

//         setOtpStep(true);
//       } else {
//         const response = await fetch('https://noteapp-0eu4.onrender.com/api/auth/verify-otp', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({
//             email: formData.email,
//             otp: formData.otp,
//           }),
//         });

//         const data = await response.text();
//         if (!response.ok) throw new Error(data.message || 'OTP verification failed');

//         navigate('/request-otp');
//       }
//     } catch (error) {
//       setErrors({ submit: error.message });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="signup-container">
//       {/* Mobile View */}
//       <div className="signup-mobile">
//         <div className="signup-mobile-header">
//           <div className="hd-logo">HD</div>
//           <h1>Sign up</h1>
//         </div>

//         <form onSubmit={handleSubmit} className="signup-form">
//           <div className="form-group">
//             <label htmlFor="fullName">Full Name</label>
//             <input
//               type="text"
//               id="fullName"
//               name="fullName"
//               value={formData.fullName}
//               onChange={handleChange}
//               className={errors.fullName ? 'error' : ''}
//               placeholder="Enter your full name"
//             />
//             {errors.fullName && <span className="error-message">{errors.fullName}</span>}
//           </div>

//           <div className="form-group">
//             <label htmlFor="email">Email</label>
//             <input
//               type="email"
//               id="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               className={errors.email ? 'error' : ''}
//               placeholder="Enter your email"
//             />
//             {errors.email && <span className="error-message">{errors.email}</span>}
//           </div>

//           <div className="form-group">
//             <label htmlFor="dateOfBirth">Date of Birth</label>
//             <input
//               type="date"
//               id="dateOfBirth"
//               name="dateOfBirth"
//               value={formData.dateOfBirth}
//               onChange={handleChange}
//               className={errors.dateOfBirth ? 'error' : ''}
//             />
//             {errors.dateOfBirth && <span className="error-message">{errors.dateOfBirth}</span>}
//           </div>

//           {!otpStep ? (
//             <button type="submit" className="signup-button" disabled={isLoading}>
//               {isLoading ? 'Sending OTP...' : 'Send OTP'}
//             </button>
//           ) : (
//             <>
//               <div className="form-group">
//                 <label htmlFor="otp">Enter OTP</label>
//                 <input
//                   type="text"
//                   id="otp"
//                   name="otp"
//                   ref={otpInputRef}
//                   value={formData.otp}
//                   onChange={handleChange}
//                   placeholder="Enter OTP"
//                 />
//               </div>
//               <button type="submit" className="signup-button" disabled={isLoading}>
//                 {isLoading ? 'Verifying...' : 'Sign up'}
//               </button>
//             </>
//           )}

//           {errors.submit && <div className="error-message submit-error">{errors.submit}</div>}
//         </form>

//         <div className="signup-link">
//           Already have an account? <Link to="/signin">Sign in</Link>
//         </div>
//       </div>

//       {/* Desktop View */}
//       <div className="signup-desktop">
//         <div className="signup-desktop-left">
//           <div className="hd-logo">HD</div>
//           <h1>Sign up</h1>

//           <form onSubmit={handleSubmit} className="signup-form">
//             <div className="form-group">
//               <label htmlFor="fullNameDesktop">Full Name</label>
//               <input
//                 type="text"
//                 id="fullNameDesktop"
//                 name="fullName"
//                 value={formData.fullName}
//                 onChange={handleChange}
//                 className={errors.fullName ? 'error' : ''}
//                 placeholder="Enter your full name"
//               />
//               {errors.fullName && <span className="error-message">{errors.fullName}</span>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="emailDesktop">Email</label>
//               <input
//                 type="email"
//                 id="emailDesktop"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 className={errors.email ? 'error' : ''}
//                 placeholder="Enter your email"
//               />
//               {errors.email && <span className="error-message">{errors.email}</span>}
//             </div>

//             <div className="form-group">
//               <label htmlFor="dateOfBirthDesktop">Date of Birth</label>
//               <input
//                 type="date"
//                 id="dateOfBirthDesktop"
//                 name="dateOfBirth"
//                 value={formData.dateOfBirth}
//                 onChange={handleChange}
//                 className={errors.dateOfBirth ? 'error' : ''}
//               />
//               {errors.dateOfBirth && <span className="error-message">{errors.dateOfBirth}</span>}
//             </div>

//             {!otpStep ? (
//               <button type="submit" className="signup-button" disabled={isLoading}>
//                 {isLoading ? 'Sending OTP...' : 'Send OTP'}
//               </button>
//             ) : (
//               <>
//                 <div className="form-group">
//                   <label htmlFor="otpDesktop">Enter OTP</label>
//                   <input
//                     type="text"
//                     id="otpDesktop"
//                     name="otp"
//                     ref={otpInputRef}
//                     value={formData.otp}
//                     onChange={handleChange}
//                     placeholder="Enter OTP"
//                   />
//                 </div>
//                 <button type="submit" className="signup-button" disabled={isLoading}>
//                   {isLoading ? 'Verifying...' : 'Sign up'}
//                 </button>
//               </>
//             )}

//             {errors.submit && <div className="error-message submit-error">{errors.submit}</div>}
//           </form>

//           <div className="signup-link">
//             Already have an account? <Link to="/signin">Sign in</Link>
//           </div>
//         </div>

//         <div className="signup-desktop-right">
//           <div className="abstract-background"></div>
//           <img src="/bg.png" alt="User Avatar" className="user-avatar" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignUp;

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './SignUp.css';

const SignUp = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    dateOfBirth: ''
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = 'Full name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.dateOfBirth) newErrors.dateOfBirth = 'Date of birth is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    setSuccessMessage('');

    try {
      const response = await fetch('https://noteapp-0eu4.onrender.com/api/auth/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.email,
          dob: formData.dateOfBirth,
        }),
      });

      const data = await response.text();

      if (!response.ok) throw new Error(data || 'Signup failed');

      setSuccessMessage("User registered. Now go to the Sign In page for OTP verification.");

      setTimeout(() => {
        navigate('/signin', { state: { email: formData.email } });
      }, 2000);

    } catch (error) {
      setErrors({ submit: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signup-container">
      {/* Mobile View */}
      <div className="signup-mobile">
        <div className="signup-mobile-header">
          <div className="hd-logo">HD</div>
          <h1>Sign up</h1>
        </div>

        <form onSubmit={handleSubmit} className="signup-form">
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className={errors.fullName ? 'error' : ''}
              placeholder="Enter your full name"
            />
            {errors.fullName && <span className="error-message">{errors.fullName}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={errors.email ? 'error' : ''}
              placeholder="Enter your email"
            />
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="dateOfBirth">Date of Birth</label>
            <input
              type="date"
              id="dateOfBirth"
              name="dateOfBirth"
              value={formData.dateOfBirth}
              onChange={handleChange}
              className={errors.dateOfBirth ? 'error' : ''}
            />
            {errors.dateOfBirth && <span className="error-message">{errors.dateOfBirth}</span>}
          </div>

          <button type="submit" className="signup-button" disabled={isLoading}>
            {isLoading ? 'Registering...' : 'Sign up'}
          </button>

          {errors.submit && <div className="error-message submit-error">{errors.submit}</div>}
          {successMessage && <div className="success-message">{successMessage}</div>}
        </form>

        <div className="signup-link">
          Already have an account? <Link to="/signin">Sign in</Link>
        </div>
      </div>

      {/* Desktop View */}
      <div className="signup-desktop">
        <div className="signup-desktop-left">
          <div className="hd-logo">HD</div>
          <h1>Sign up</h1>

          <form onSubmit={handleSubmit} className="signup-form">
            <div className="form-group">
              <label htmlFor="fullNameDesktop">Full Name</label>
              <input
                type="text"
                id="fullNameDesktop"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                className={errors.fullName ? 'error' : ''}
                placeholder="Enter your full name"
              />
              {errors.fullName && <span className="error-message">{errors.fullName}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="emailDesktop">Email</label>
              <input
                type="email"
                id="emailDesktop"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? 'error' : ''}
                placeholder="Enter your email"
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="dateOfBirthDesktop">Date of Birth</label>
              <input
                type="date"
                id="dateOfBirthDesktop"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                className={errors.dateOfBirth ? 'error' : ''}
              />
              {errors.dateOfBirth && <span className="error-message">{errors.dateOfBirth}</span>}
            </div>

            <button type="submit" className="signup-button" disabled={isLoading}>
              {isLoading ? 'Registering...' : 'Sign up'}
            </button>

            {errors.submit && <div className="error-message submit-error">{errors.submit}</div>}
            {successMessage && <div className="success-message">{successMessage}</div>}
          </form>

          <div className="signup-link">
            Already have an account? <Link to="/signin">Sign in</Link>
          </div>
        </div>

        <div className="signup-desktop-right">
          <div className="abstract-background"></div>
          <img src="/bg.png" alt="User Avatar" className="user-avatar" />
        </div>
      </div>
    </div>
  );
};

export default SignUp;

